

let loadMore;

async function sleepAffirm() {

  setTimeout(() => {
    loadMore = document.querySelector(".t4s-cart-total");
    affirmObserver2.observe(loadMore, { childList: true, subtree: true, attributes: true });
  }, "3000");
  
}


const affirmObserver2 = new MutationObserver(function(mutations) {
  
  let checkoutButton = document.querySelector('button[name="checkout"]');
  let latestPrice = document.querySelector(".t4s-cart__totalPrice").innerHTML.replace(/\D/g, "");
  let affirmCartSidePrice = document.querySelector(".affirm-as-low-as[data-page-type='cart']");
  
  if (latestPrice && checkoutButton && latestPrice != document.querySelector) {
    
    document.querySelector(".affirm-as-low-as[data-page-type='cart']").dataset.amount = latestPrice;
    affirm?.ui?.ready(function() {
      affirm?.ui?.refresh();
    });
    
  }

}); 


sleepAffirm();